import React from "react";
import { Avatar, Box, Paper, Typography } from "@mui/material";
import { addDays, format, isSameDay, startOfWeek } from "date-fns";
import BatchChip from "./BatchChip";

const WeekView = ({ cursor, getEventsForDayAndSlot, onBatchClick, slots }) => {
  const today = new Date();
  const weekStart = startOfWeek(cursor, { weekStartsOn: 0 });
  const days = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));

  return (
    <Paper variant="outlined" elevation={0} sx={{ borderRadius: 3, overflow: "auto" }}>
      <Box sx={{ minWidth: 980 }}>
        <Box sx={{ display: "flex", borderBottom: "1px solid", borderColor: "divider" }}>
          <Box sx={{ width: 56, borderRight: "1px solid", borderColor: "divider", p: 1 }} />
          {days.map((day) => (
            <Box
              key={day.toISOString()}
              sx={{
                flex: 1,
                p: 1,
                borderRight: "1px solid",
                borderColor: "divider",
                "&:last-of-type": { borderRight: "none" },
              }}
            >
              <Typography variant="caption" color="text.secondary">
                {format(day, "EEE")}
              </Typography>
              {isSameDay(day, today) ? (
                <Avatar sx={{ width: 24, height: 24, fontSize: 12, bgcolor: "primary.main", mt: 0.5 }}>
                  {format(day, "d")}
                </Avatar>
              ) : (
                <Typography variant="body2" sx={{ mt: 0.5 }}>
                  {format(day, "d")}
                </Typography>
              )}
            </Box>
          ))}
        </Box>

        {slots.map((slot) => (
          <Box key={slot.key} sx={{ display: "flex" }}>
            <Box
              sx={{
                width: 56,
                height: 46,
                borderRight: "1px solid",
                borderBottom: "1px solid",
                borderColor: "divider",
                px: 0.5,
                py: 0.25,
              }}
            >
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
                {slot.label}
              </Typography>
            </Box>
            {days.map((day) => {
              const events = getEventsForDayAndSlot(day, slot);
              return (
                <Box
                  key={`${day.toISOString()}-${slot.key}`}
                  sx={{
                    flex: 1,
                    height: 46,
                    borderRight: "1px solid",
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    p: 0.25,
                    overflow: "hidden",
                  }}
                >
                  {events.map((batch) => (
                    <BatchChip
                      key={`${day.toISOString()}-${slot.key}-${batch.id}`}
                      batch={batch}
                      onClick={onBatchClick}
                    />
                  ))}
                  {events.length === 0 ? (
                    <Typography variant="caption" color="text.disabled" sx={{ fontSize: 10 }}>
                      Free
                    </Typography>
                  ) : null}
                </Box>
              );
            })}
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default WeekView;

